import { Component, ContentChild, Input } from '@angular/core';
import { ColumnOptions } from '../../models';

@Component({
  selector: 'app-column',
  templateUrl: './column.component.html',
  styleUrl: './column.component.scss',
})
export class ColumnComponent {

  @ContentChild('content')
  contentTemplate: any;

  @Input()
  fontSize: number = 0.875;

  @Input()
  column!: ColumnOptions;

  @Input()
  data: any;

  @Input()
  cellStyle: { [key: string]: string } = {};
}
